var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"datePicker",staticClass:"form-input form-datepicker form-control form-input-bordered",class:{ 'cursor-not-allowed': _vm.disabled },attrs:{"disabled":_vm.disabled,"type":"text","placeholder":_vm.placeholder}})}
var staticRenderFns = []

export { render, staticRenderFns }